import React, { memo } from 'react';

export const MapIcon = memo(() => {
    return (
        <div style={{
            display: 'inline-flex',
            textAlign: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.5rem',
            position: "relative",
            textShadow: "0 0 3px #000000ff",
        }}>📍</div>
    )
});